import { render, staticRenderFns } from "./WeChatUser.vue?vue&type=template&id=532923ae&scoped=true"
import script from "./WeChatUser.vue?vue&type=script&lang=js"
export * from "./WeChatUser.vue?vue&type=script&lang=js"
import style0 from "./WeChatUser.vue?vue&type=style&index=0&id=532923ae&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532923ae",
  null
  
)

export default component.exports